import UserPreferenceSingleton from '../helpers/userPreferenceSingleton';
import LocalDbService, { MY_TIME_LOG_NAME, UPDATE_ON_ID } from './localDbService';
import { RawTimeTrackingDataInterface } from '../mobx/interfaces/task';

interface MyTimeLogCacheServiceProps {
  organizationId: string;
  dbName?: string;
  tableName?: string;
}

interface MyTimeLogDbRow {
  id: string;
  date: string;
  createdAt: string;
  projectId: string;
  value: RawTimeTrackingDataInterface;
}

let singleton: MyTimeLogCacheService | undefined;
let organizationId: string | undefined;

export default class MyTimeLogCacheService extends LocalDbService {
  constructor(props: MyTimeLogCacheServiceProps) {
    const db_name = `${props.organizationId}`;
    props.dbName = db_name;
    props.tableName = MY_TIME_LOG_NAME;
    super(props);
  }

  static getInstance() {
    const company = UserPreferenceSingleton.getInstance().getWorkspace();
    if (company) {
      if (!singleton || organizationId !== company?.id) {
        organizationId = company?.id;
        singleton = new MyTimeLogCacheService({ organizationId: company?.id });
      }
    }
    return singleton;
  }

  static removeInstance() {
    if (singleton) singleton.closeDb();
    organizationId = undefined;
    singleton = undefined;
  }

  async getMyTimeLogByWorkspace(): Promise<RawTimeTrackingDataInterface[]> {
    const rows: MyTimeLogDbRow[] = await this.getDb()
      .filter((x: MyTimeLogDbRow) => x)
      .sortBy('date');
    const result = rows?.map((x) => x.value);
    return result || [];
  }

  async setMyTimeLogData(value: RawTimeTrackingDataInterface[], companyId: string) {
    if (!value || companyId !== organizationId) return false;
    const result = await this.addBulk(value);
    return result;
  }

  async updateTimeLogList(data: RawTimeTrackingDataInterface[], archived: string[], workspace_id: string) {
    if (workspace_id !== organizationId) return false;
    await this.syncList(data, archived);
  }

  async getLastUpdatedTimeMonthWise(workspace_id?: string) {
    const result = await super.getLastUpdatedTime(`MY_TIMELOG_MONTH_WISE_${workspace_id}`);
    return result;
  }

  async setLastUpdatedTimeMonthWise(value: Record<string, string>, companyId: string) {
    if (companyId !== organizationId) return false;
    const result = await super.setLastUpdatedTime(`MY_TIMELOG_MONTH_WISE_${companyId}`, value);
    return result;
  }

  async getLastUpdatedTime(workspace_id?: string) {
    const result = await super.getLastUpdatedTime(`${UPDATE_ON_ID.MY_TIME_LOG}_${workspace_id}`);
    return result;
  }

  async setLastUpdatedTime(value: string, companyId: string) {
    if (companyId !== organizationId) return false;
    const result = await super.setLastUpdatedTime(`${UPDATE_ON_ID.MY_TIME_LOG}_${companyId}`, value);
    return result;
  }
}
